import { FaMinus, FaPlus } from "react-icons/fa";
import { FiArrowRight, FiShoppingBag } from "react-icons/fi";
import { formatPersianPrice } from "../../../services/customerMenuModel";
import { formatPersianNumber } from "../../../utils/persianNumber";

// Shared structure/behavior for every food-detail theme except Classic
// (which composes a different, older pattern). Each theme supplies its own
// visual tokens via `theme` — colors, borders, fonts — while this component
// owns the layout, the quantity stepper, and the add-to-cart logic.
const FoodDetailThemeBase = ({ item, quantity, changeQuantity, goToMenu, goToCart, theme }) => {
  const {
    pageStyle,
    headerClassName,
    headerStyle,
    headerInnerClassName,
    iconButtonClassName,
    titleClassName,
    titleStyle,
    badgeClassName,
    badgeStyle,
    cardClassName,
    cardStyle,
    PlaceholderIcon,
    placeholderClassName,
    placeholderStyle,
    itemTitleClassName,
    itemTitleStyle,
    descriptionClassName,
    priceStyle,
    stepperClassName,
    stepperStyle,
    ctaClassName,
    ctaStyle,
  } = theme;

  return (
    <div className="min-h-screen pb-28" dir="rtl" style={pageStyle}>
      <header className={headerClassName} style={headerStyle}>
        <div className={headerInnerClassName}>
          <button type="button" onClick={goToMenu} aria-label="بازگشت به منو" className={iconButtonClassName}><FiArrowRight /></button>
          <p className={titleClassName} style={titleStyle}>جزئیات آیتم</p>
          <button type="button" onClick={goToCart} aria-label="مشاهده سبد" className={`relative ${iconButtonClassName}`}>
            <FiShoppingBag />
            {quantity > 0 && <span className={badgeClassName} style={badgeStyle}>{formatPersianNumber(quantity)}</span>}
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-2xl p-4 sm:p-6">
        <div className={cardClassName} style={cardStyle}>
          {item.image ? (
            <img src={item.image} alt={item.name} className="aspect-[4/3] w-full object-cover sm:aspect-[16/9]" />
          ) : (
            <div className={placeholderClassName} style={placeholderStyle}><PlaceholderIcon /></div>
          )}
          <div className="p-5">
            <h1 className={itemTitleClassName} style={itemTitleStyle}>{item.name}</h1>
            {item.description && <p className={descriptionClassName}>{item.description}</p>}
            <p className="mt-4 text-lg font-black" style={priceStyle}>{formatPersianPrice(item.price)}</p>
          </div>
        </div>
      </main>

      <div className="fixed inset-x-0 bottom-0 p-3">
        <div className="mx-auto flex max-w-md items-center gap-3">
          {quantity > 0 ? (
            <div className={stepperClassName} style={stepperStyle}>
              <button type="button" onClick={() => changeQuantity(-1)} aria-label={`کم کردن ${item.name}`} className="flex h-12 w-12 items-center justify-center"><FaMinus size={12} /></button>
              <span className="w-8 text-center font-bold">{formatPersianNumber(quantity)}</span>
              <button type="button" onClick={() => changeQuantity(1)} aria-label={`اضافه کردن ${item.name}`} className="flex h-12 w-12 items-center justify-center"><FaPlus size={12} /></button>
            </div>
          ) : null}
          <button type="button" onClick={() => (quantity ? goToCart() : changeQuantity(1))} className={ctaClassName} style={ctaStyle}>
            {quantity ? "مشاهده سبد" : "افزودن به سبد سفارش"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FoodDetailThemeBase;
